import { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheckCircle, FiAlertCircle } from 'react-icons/fi';

// Lightweight toast hook: const { toast, ToastHost } = useToast()
export function useToast() {
  const [msg, setMsg] = useState(null);

  const toast = useCallback((text, type = 'success') => {
    setMsg({ text, type });
    setTimeout(() => setMsg(null), 3200);
  }, []);

  const ToastHost = () => (
    <AnimatePresence>
      {msg && (
        <motion.div
          className={`toast ${msg.type}`}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
        >
          {msg.type === 'error' ? <FiAlertCircle color="var(--danger)" /> : <FiCheckCircle color="var(--success)" />}
          <span>{msg.text}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return { toast, ToastHost };
}
